const transitions = {
  color: 'color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
  background: 'background 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
}

export default transitions
